import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideoClip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVideoClip"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM4.5 4.5V7.125H7V4.5H4.5ZM17 4.5V7.125H19.5V4.5H17ZM19.5 8.625H17V11.25H19.5V8.625ZM19.5 12.75H17V15.8333H19.5V12.75ZM19.5 17.3333H17V19.5H19.5V17.3333ZM15.5 12.75V11.25H8.5V12.75H15.5ZM7 19.5V16.875H4.5V19.5H7ZM4.5 15.375H7V12.75H4.5V15.375ZM4.5 11.25H7V8.625H4.5V11.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVideoClip;
